// istanbul ignore file
import React from 'react';
import Input from '@cotyorg/ccx-atoms/Input';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import Icon from '@cotyorg/ccx-atoms/Icon';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const generateSearchButtonClassNames = ({
  searchButtonHidden,
}) => classNames('search__button', {
  'search__button--hidden': searchButtonHidden,
});

const createSearchURL = ({
  presentationLocale,
  searchPath,
}) => {
  if (searchPath) {
    return presentationLocale ? `/${presentationLocale}${searchPath}` : searchPath;
  }

  return null;
};

const submitSearchForm = ({
  e,
  searchPath,
  searchFieldName,
}) => {
  if (!searchPath || e.currentTarget[searchFieldName].value.length === 0) {
    e.preventDefault();
  }
};

const SearchForm = ({
  onInputUpdate,
  term,
  clearSearchAndInput,
  clearSearchIconSrc,
  searchIconSrc,
  placeholder,
  presentationLocale,
  searchPath,
  searchButtonText,
  searchButtonHidden = false,
  searchFieldName,
}) => (
  <form
    action={createSearchURL({
      presentationLocale, searchPath,
    })}
    className="search__form"
    onSubmit={e => submitSearchForm({ e, searchPath, searchFieldName })}
  >
    <Input
      testAttribute="search-input"
      type="text"
      size="large"
      extraClass="search__input"
      onChange={onInputUpdate}
      placeholder={placeholder}
      value={term || ''}
      name={searchFieldName}
    />
    {
      searchPath && (
        <button
          data-test="search-submit-button"
          type="submit"
          className={generateSearchButtonClassNames({
            searchButtonHidden,
          })}
        >
          {searchButtonText}
        </button>
      )
    }
    {
      term ?
        (
          <IconButton
            testAttribute="search-clear-button"
            extraClass="search__clear-button"
            size="small"
            iconSrc={clearSearchIconSrc}
            onClick={clearSearchAndInput}
          />
        ) :
        (
          <Icon
            testAttribute="search-button"
            extraClass="search__icon"
            size="small"
            iconSrc={searchIconSrc}
          />
        )
    }
  </form>
);

SearchForm.propTypes = {
  clearSearchAndInput: PropTypes.func.isRequired,
  onInputUpdate: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  term: PropTypes.string,
  clearSearchIconSrc: PropTypes.string,
  searchIconSrc: PropTypes.string,
  presentationLocale: PropTypes.string,
  searchPath: PropTypes.string,
  searchFieldName: PropTypes.string.isRequired,
  searchButtonText: PropTypes.string,
  searchButtonHidden: PropTypes.bool,
};

export default SearchForm;
